import type { SVGProps } from 'react';

export type IconName =
  | 'arrow-left'
  | 'app-cluster'
  | 'bell'
  | 'calendar'
  | 'check'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'clock'
  | 'close'
  | 'eye'
  | 'file'
  | 'globe'
  | 'help'
  | 'home'
  | 'image'
  | 'location'
  | 'message'
  | 'more'
  | 'palette'
  | 'paperclip'
  | 'people'
  | 'pie'
  | 'plus'
  | 'publish'
  | 'save'
  | 'send'
  | 'share'
  | 'users'
  | 'website'
  | 'book'
  | 'briefcase'
  | 'code'
  | 'credit-card'
  | 'device-plus'
  | 'download'
  | 'designer'
  | 'headset'
  | 'logout'
  | 'mail'
  | 'menu'
  | 'phone'
  | 'search'
  | 'settings'
  | 'user'
  | 'hand'
  | 'tool'
  | 'camera'
  | 'music'
  | 'kitchen'
  | 'children'
  | 'parking'
  | 'prayer'
  | 'reply'
  | 'edit'
  | 'smile'
  | 'trash'
  | 'lock'
  | 'tag'
  | 'heart'
  | 'church'
  | 'network'
  | 'panel-left-close'
  | 'user-plus'
  | 'filter'
  | 'key'
  | 'warning'
  | 'sparkles'
  | 'trend';

type IconProps = Omit<SVGProps<SVGSVGElement>, 'children'> & {
  name: IconName;
  size?: number;
};

const paths: Record<IconName, React.ReactNode> = {
  'arrow-left': <><path d="M19 12H5" /><path d="m12 19-7-7 7-7" /></>,
  'app-cluster': <><circle cx="12" cy="7" r="3.2" /><circle cx="7.2" cy="16.2" r="3.2" /><circle cx="16.8" cy="16.2" r="3.2" /></>,
  bell: <><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" /><path d="M13.7 21a2 2 0 0 1-3.4 0" /></>,
  calendar: <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M16 3v4M8 3v4M3 10h18" /><path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01" /></>,
  check: <path d="m5 12 4 4L19 6" />,
  'chevron-down': <path d="m7 10 5 5 5-5" />,
  'chevron-left': <path d="m15 18-6-6 6-6" />,
  'chevron-right': <path d="m9 18 6-6-6-6" />,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  close: <path d="m6 6 12 12M18 6 6 18" />,
  eye: <><path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z" /><circle cx="12" cy="12" r="2.5" /></>,
  file: <><path d="M6 2h8l4 4v16H6z" /><path d="M14 2v5h5M9 13h6M9 17h5" /></>,
  globe: <><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" /></>,
  help: <><circle cx="12" cy="12" r="9" /><path d="M9.6 9a2.6 2.6 0 1 1 3.6 2.4c-.8.4-1.2.9-1.2 1.6M12 17h.01" /></>,
  home: <><path d="m3 11 9-8 9 8" /><path d="M5 10v11h14V10M9 21v-7h6v7" /></>,
  image: <><rect x="3" y="4" width="18" height="16" rx="2" /><circle cx="9" cy="10" r="2" /><path d="m21 15-4-4L5 20" /></>,
  location: <><path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z" /><circle cx="12" cy="10" r="2.5" /></>,
  message: <><path d="M4 4h16v12H9l-5 4z" /><path d="M8 9h8M8 12h5" /></>,
  more: <><circle cx="5" cy="12" r="1" fill="currentColor" stroke="none" /><circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" /><circle cx="19" cy="12" r="1" fill="currentColor" stroke="none" /></>,
  palette: <><path d="M12 3a9 9 0 0 0 0 18h1.4a1.8 1.8 0 0 0 1.3-3.1 1.8 1.8 0 0 1 1.3-3.1h1a4 4 0 0 0 4-4A9 9 0 0 0 12 3Z" /><circle cx="7.5" cy="11" r="1" fill="currentColor" stroke="none" /><circle cx="9.5" cy="7.5" r="1" fill="currentColor" stroke="none" /><circle cx="14" cy="7" r="1" fill="currentColor" stroke="none" /></>,
  paperclip: <path d="m21.4 11.6-8.9 8.9a6 6 0 0 1-8.5-8.5l9.2-9.2a4 4 0 0 1 5.7 5.7l-9.2 9.2a2 2 0 0 1-2.9-2.8l8.6-8.6" />,
  people: <><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8" /></>,
  pie: <><path d="M5 13c.8-3 3.5-4.5 7-4.5s6.2 1.5 7 4.5" /><path d="M3 14c1.2-.9 1.8.9 3 0s1.8.9 3 0 1.8.9 3 0 1.8.9 3 0 1.8.9 3 0 1.8.9 3 0" /><path d="m4.5 15 1.2 5h12.6l1.2-5" /><path d="M9 6c-1-1 .8-1.8 0-3M15 6c1-1-.8-1.8 0-3M9.5 11.5l1-1M14.5 11.5l-1-1" /></>,
  plus: <path d="M12 5v14M5 12h14" />,
  publish: <><path d="M12 16V3M7 8l5-5 5 5" /><path d="M5 14v7h14v-7" /></>,
  save: <><path d="M4 3h14l2 2v16H4z" /><path d="M8 3v6h8V3M8 21v-7h8v7" /></>,
  send: <><path d="m22 2-7 20-4-9-9-4Z" /><path d="M22 2 11 13" /></>,
  share: <><path d="M12 3v12" /><path d="m7 8 5-5 5 5" /><path d="M5 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-1" /></>,
  users: <><circle cx="9" cy="8" r="3" /><path d="M3 21v-2a6 6 0 0 1 12 0v2M16 4a3 3 0 0 1 0 6M18 14a5 5 0 0 1 3 5v2" /></>,
  website: <><rect x="3" y="4" width="18" height="14" rx="1.5" /><path d="M3 8h18M9 21h6M12 18v3" /></>,
  book: <><path d="M4 5a3 3 0 0 1 3-2h5v17H7a3 3 0 0 0-3 2Z" /><path d="M20 5a3 3 0 0 0-3-2h-5v17h5a3 3 0 0 1 3 2Z" /></>,
  briefcase: <><rect x="3" y="7" width="18" height="13" rx="2" /><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 12h18M10 12v2h4v-2" /></>,
  code: <><path d="m8 9-3 3 3 3M16 9l3 3-3 3M14 5l-4 14" /></>,
  'credit-card': <><rect x="2" y="5" width="20" height="14" rx="2" /><path d="M2 10h20M6 15h4" /></>,
  'device-plus': <><rect x="6" y="2" width="12" height="20" rx="2" /><path d="M10 5h4M10 18h4M12 9v5M9.5 11.5h5" /></>,
  download: <><path d="M12 3v12m-5-5 5 5 5-5" /><path d="M4 17v4h16v-4" /></>,
  designer: <><path d="M5 4h9a3 3 0 0 1 3 3v1" /><path d="M5 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7" /><path d="m13 18 6.7-6.7a1.8 1.8 0 0 1 2.5 2.5L15.5 20.5 12 21Z" /><path d="m18.5 12.5 3 3M8 9h5M8 13h3" /><path d="m18 3 .5 1.5L20 5l-1.5.5L18 7l-.5-1.5L16 5l1.5-.5Z" /></>,
  headset: <><path d="M4 14v-2a8 8 0 0 1 16 0v2" /><path d="M4 14h3v6H5a2 2 0 0 1-2-2v-2a2 2 0 0 1 1-2ZM20 14h-3v6h2a2 2 0 0 0 2-2v-2a2 2 0 0 0-1-2ZM17 20c0 1-2 2-4 2" /></>,
  logout: <><path d="M10 4H5v16h5M14 8l4 4-4 4M18 12H9" /></>,
  mail: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3 7 9 6 9-6" /></>,
  menu: <><path d="M4 7h16M4 12h16M4 17h16" /></>,
  phone: <path d="M6.5 3h3l1.5 5-2 1.5a15 15 0 0 0 5.5 5.5l1.5-2 5 1.5v3A2.5 2.5 0 0 1 18.5 21C9.9 21 3 14.1 3 5.5A2.5 2.5 0 0 1 5.5 3Z" />,
  search: <><circle cx="11" cy="11" r="7" /><path d="m20 20-4-4" /></>,
  settings: <><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1-2.8 2.8-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.6v.2h-4V21a1.7 1.7 0 0 0-1-1.6 1.7 1.7 0 0 0-1.9.3l-.1.1L4.2 17l.1-.1a1.7 1.7 0 0 0 .3-1.9A1.7 1.7 0 0 0 3 14H2.8v-4H3a1.7 1.7 0 0 0 1.6-1 1.7 1.7 0 0 0-.3-1.9L4.2 7 7 4.2l.1.1A1.7 1.7 0 0 0 9 4.6 1.7 1.7 0 0 0 10 3V2.8h4V3a1.7 1.7 0 0 0 1 1.6 1.7 1.7 0 0 0 1.9-.3l.1-.1L19.8 7l-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.6 1h.2v4H21a1.7 1.7 0 0 0-1.6 1Z" /></>,
  user: <><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></>,
  hand: <><path d="M7 11V6a1.5 1.5 0 0 1 3 0v4-6a1.5 1.5 0 0 1 3 0v6-5a1.5 1.5 0 0 1 3 0v6-3a1.5 1.5 0 0 1 3 0v5c0 5-3 8-8 8-3 0-5-2-7-5l-2-3a1.7 1.7 0 0 1 2.8-1.9L7 14Z" /></>,
  tool: <><path d="m14 6 4-4 4 4-4 4" /><path d="m16 8-5 5" /><path d="m12 14-7 7-3-3 7-7" /><path d="m4 4 6 6" /></>,
  camera: <><path d="M4 7h4l2-3h4l2 3h4v13H4Z" /><circle cx="12" cy="13" r="4" /></>,
  music: <><path d="M9 18V5l10-2v13" /><circle cx="6" cy="18" r="3" /><circle cx="16" cy="16" r="3" /></>,
  kitchen: <><path d="M6 3v8M3 3v5a3 3 0 0 0 6 0V3M6 11v10M16 3v18M16 3c4 2 5 7 0 10" /></>,
  children: <><circle cx="8" cy="7" r="3" /><circle cx="17" cy="8" r="2.5" /><path d="M2 21v-2a6 6 0 0 1 12 0v2M14 16a5 5 0 0 1 7 4v1" /></>,
  parking: <><rect x="4" y="2" width="16" height="20" rx="2" /><path d="M9 18V6h4a4 4 0 0 1 0 8H9M9 14h4" /></>,
  prayer: <><path d="M9 4c2 3 2 6 0 9l-4 7M15 4c-2 3-2 6 0 9l4 7M9 13h6M8 18h8" /></>,
  reply: <><path d="m9 17-5-5 5-5" /><path d="M4 12h10a6 6 0 0 1 6 6v1" /></>,
  edit: <><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4Z" /></>,
  smile: <><circle cx="12" cy="12" r="9" /><path d="M8.5 10h.01M15.5 10h.01M8 14.5a5 5 0 0 0 8 0" /></>,
  trash: <><path d="M4 7h16M9 7V4h6v3M7 7l1 14h8l1-14M10 11v6M14 11v6" /></>,
  lock: <><rect x="4" y="10" width="16" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3" /></>,
  tag: <><path d="M20 13 13 20 3 10V3h7Z" /><circle cx="8" cy="8" r="1" /></>,
  heart: <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z" />,
  church: <><path d="M12 2v5M9.5 4.5h5" /><path d="m6 10 6-4 6 4v11H6Z" /><path d="M3 13h3M18 13h3M10 21v-6h4v6" /></>,
  network: <><circle cx="12" cy="5" r="2.5" /><circle cx="5" cy="18" r="2.5" /><circle cx="19" cy="18" r="2.5" /><path d="M12 7.5v4M5 15.5v-2h14v2" /></>,
  'panel-left-close': <><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M9 4v16m7-5-3-3 3-3" /></>,
  'user-plus': <><circle cx="9" cy="8" r="4" /><path d="M2 21a7 7 0 0 1 14 0M19 8v6M16 11h6" /></>,
  filter: <><path d="M4 6h16M7 12h10M10 18h4" /></>,
  key: <><circle cx="7.5" cy="16.5" r="4.5" /><path d="m10.7 13.3 9.3-9.3M16 8l3 3M13.5 10.5l3 3" /></>,
  warning: <><path d="M10.3 3.8 2.4 18a2 2 0 0 0 1.8 3h15.6a2 2 0 0 0 1.8-3L13.7 3.8a2 2 0 0 0-3.4 0Z" /><path d="M12 9v4M12 17h.01" /></>,
  sparkles: <><path d="m12 3 1.2 3.8L17 8l-3.8 1.2L12 13l-1.2-3.8L7 8l3.8-1.2Z" /><path d="m5 14 .8 2.2L8 17l-2.2.8L5 20l-.8-2.2L2 17l2.2-.8ZM19 13l.7 1.8 1.8.7-1.8.7L19 18l-.7-1.8-1.8-.7 1.8-.7Z" /></>,
  trend: <><path d="M4 19V5" /><path d="M4 19h16" /><path d="m7 15 3-4 3 2 5-7" /><circle cx="7" cy="15" r="1" fill="currentColor" stroke="none" /><circle cx="10" cy="11" r="1" fill="currentColor" stroke="none" /><circle cx="13" cy="13" r="1" fill="currentColor" stroke="none" /><circle cx="18" cy="6" r="1" fill="currentColor" stroke="none" /></>,
};

export function Icon({ name, size = 20, ...props }: IconProps) {
  return (
    <svg
      aria-hidden={props['aria-label'] ? undefined : true}
      fill="none"
      height={size}
      viewBox="0 0 24 24"
      width={size}
      {...props}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.75"
    >
      {paths[name]}
    </svg>
  );
}
